module.exports = __webpack_public_path__ + "img/lutsai.18de6e5b.png";